<template>
  <cx-showcase-section :name="name" :link="link" class="cx-button-showcase">
    <div class="cxu-d-flex cxu-gap-10">
      <cx-date-range-picker
        v-model="selectedDate"
        :minDate="minDate"
        :quickSelect="quickSelectOptions"
        :showActionPanel="true"
        :freezeTo="now"
        :dateFormat="dateFormat"
        label="Range Selector"/>
      <cx-date-range-picker
        v-model="selectedDate"
        :minDate="minDate"
        :quickSelect="quickSelectOptions"
        :now="now"
        :showActionPanel="true"
        :showQuickSelectTab="true"
        :freezeTo="now"
        :dateFormat="dateFormat"
        :events="events"
        label="Range Selector with events"/>
      <cx-date-range-picker
        v-model="selectedDate"
        :minDate="minDate"
        :quickSelect="quickSelectOptions"
        :showQuickSelectTab="true"
        :now="now"
        :showActionPanel="true"
        :dateFormat="dateFormat"
        :allowFutureDates="true"
        :events="events"
        label="Free Range Selector with events"/>
      <cx-date-range-picker
        v-model="selectedDate"
        :minDate="minDate"
        :quickSelect="quickSelectOptions"
        :showQuickSelectTab="true"
        :now="now"
        :showActionPanel="true"
        :freezeTo="now"
        :dateFormat="dateFormat"
        label="Range Selector loading"
        :loading="true"/>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxDateRangePicker from '@/components/datePickers/CxDateRangePicker.vue';
import { startOfToday, startOfYesterday, sub, subHours, subDays, subMonths } from 'date-fns';
import datetimehelper from '@/utils/datetimehelper';

export default {
  name: 'CxDatePickerShowcase',
  components: {
    CxShowcaseSection,
    CxDateRangePicker
  },
  data() {
    return {
      name: 'CxDateRangePicker',
      link: '',
      date: new Date(),
      now: new Date(),
      minDate: sub(startOfToday(), { months: 1 }),
      dateFormat: datetimehelper.LOCALE_DATE_FORMAT,
      events: [new Date(), startOfYesterday(), sub(new Date(), { days: 10 }), new Date('2022-07-28')],
      quickSelectOptions: [
        { label: 'Last 24h', range: [subHours(new Date(), 24), new Date()] },
        { label: 'Last 7 days', range: [subDays(new Date(), 7), new Date()] },
        { label: 'Last month', range: [subMonths(new Date(), 1), new Date()] },
        { label: 'Last 3 months', range: [subMonths(new Date(), 3), new Date()] },
      ]
    };
  },
  computed: {
    selectedDate: {
      get() { return [this.date, new Date()]; },
      set(value) { [this.date] = value; }
    }
  }
};

</script>